import React from "react";
import "../styles/bonificaciones.css";

const currency = new Intl.NumberFormat("es-EC", { style: "currency", currency: "USD" });

export default function BonificacionesHistoricaDetail({ bonificacion, onClose }) {

    if (!bonificacion) {
        return (
            <div className="management-card bonificacion-detail empty h-100">
                <p className="text-muted mb-1">Selecciona una bonificacion para ver el detalle.</p>
                <small className="text-muted">Tip: filtra por referente, referido o estado.</small>
            </div>
        );
    }

    return (
        <div className="management-card bonificacion-detail h-100 d-flex flex-column">
            <div className="d-flex justify-content-between align-items-start mb-3">
                <div>
                    <p className="management-eyebrow mb-1">Detalle de bonificacion</p>
                    <h6 className="mb-0">Bonificacion #{bonificacion.id}</h6>
                    <small className="text-muted">
                        Generada: {bonificacion.fechaGeneracion ? new Date(bonificacion.fechaGeneracion).toLocaleString() : "-"}
                    </small>
                </div>
                <button type="button" className="btn btn-link text-decoration-none text-muted p-0" onClick={onClose}>
                    Cerrar
                </button>
            </div>

            <div className="detail-grid mb-3">
                <div>
                    <p className="text-muted mb-1">Referente</p>
                    <h6 className="mb-0">{bonificacion.referente || "No asignado"}</h6>
                </div>
                <div>
                    <p className="text-muted mb-1">Referido</p>
                    <h6 className="mb-0">{bonificacion.referido || "No disponible"}</h6>
                </div>
                <div>
                    <p className="text-muted mb-1">Monto</p>
                    <h6 className="mb-0">{currency.format(bonificacion.monto || 0)}</h6>
                </div>
                <div>
                    <p className="text-muted mb-1">Estado actual</p>
                    <h6 className="mb-0 text-capitalize">{bonificacion.estado || "Sin estado"}</h6>
                </div>
            </div>

            {bonificacion.estado === "anulada" ? (
                <div className="alert alert-warning d-flex align-items-start gap-2 py-2 px-3 mb-0" role="alert">
                    <i className="bi bi-clock-history flex-shrink-0 mt-1" />
                    <small>Esta bonificación venció sin ser cobrada y fue anulada automáticamente.</small>
                </div>
            ) : (
                <div className="alert alert-success d-flex align-items-start gap-2 py-2 px-3 mb-0" role="alert">
                    <i className="bi bi-check-circle flex-shrink-0 mt-1" />
                    <small>Esta bonificación fue cobrada y no puede ser modificada.</small>
                </div>
            )}
        </div>
    );
}
